import React from 'react';
import { useInView } from 'react-intersection-observer';

import { Link } from 'gatsby';
import { useGraphQL, useInstagram } from '../hooks';
import { Banner } from './banner';

function GiftcardLink() {
  return (
    <div className="px-4 bg-white sm:px-6 lg:px-8">
      <div className="py-12 mx-auto space-y-12 max-w-7xl">
        <Banner
          bannerColor="sky-blue"
          heading={
            <span className="text-3xl md:text-5xl lg:text-6xl">
              Blue Cow Giftcards
            </span>
          }
          slug="https://squareup.com/gift/404GM6V6MW2NH/order"
        />
        <a
          href="https://squareup.com/gift/404GM6V6MW2NH/order"
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-center px-6 py-2 mx-auto text-xl text-white uppercase rounded-md w-96 bg-slate font-dots"
        >
          Click here for giftcards
        </a>
      </div>
    </div>
  );
}

export { GiftcardLink };
